import { render, staticRenderFns } from "./TaskFocusThreadItem.vue?vue&type=template&id=005a87b2&scoped=true&"
import script from "./TaskFocusThreadItem.vue?vue&type=script&lang=js&"
export * from "./TaskFocusThreadItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskFocusThreadItem.vue?vue&type=style&index=0&id=005a87b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005a87b2",
  null
  
)

export default component.exports